import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import { Modal, Button, CardMedia, Input, TextField } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>
  type?: 'add' | 'edit';
}

export default function AddCategory({ open, onClose, setOpen, type = 'add' }: ModalProps) {

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  return (
    <Modal
      className="modal addCategory_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{type === 'edit' ? 'Edit Category' : 'Add Category'}</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>
          <form className="form" action="">
            <div className="control_group" >
              <label htmlFor="icon-button-file">Upload Image</label>
              {image ? (
                <div className="upload_image no_radius">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia
                        component="img"
                        image={image}
                        alt="photo"
                      />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label
                  className="upload_image no_radius"
                  htmlFor="icon-button-file"
                >
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(
                      event: ChangeEvent<HTMLInputElement>
                    ) => {
                      const files = (
                        event.target as HTMLInputElement
                      ).files;
                      if (
                        files &&
                        files[0].type.includes("image")
                      ) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        setAlertType(0);
                        setShowAlert(true);
                        setAlertMessage(
                          "This field only accepts images."
                        );
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="icon"
                        />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group">
              <label htmlFor="categoryName">Category Name</label>
              <TextField placeholder="Enter Category Name" id="categoryName"
                fullWidth hiddenLabel></TextField>
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
              <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit</Button>
            </div>
          </form>
        </div>
      </div>
    </Modal >
  )
}
